import { MdHome } from "react-icons/md";
import { FaGreaterThan } from "react-icons/fa6";
import './ViewReportsPageCSS/ViewReportImageSection.css';

export default function ViewReportImageSection() {
    return (
        <>
            <div className="packageFirstContainer viewReportImageSection">
                <div className="packageFirstUpperSection viewReportImageUpperSection">
                    <h2 className='rb-title'>View Reports</h2>
                    <div className="viewReportUpperText">
                        {/* <p><MdHome size={30} style={{ color: "#0A8E7F" }} /><FaGreaterThan size={15} />View Report</p> */}
                    </div>

                </div>
            </div>
        </>
    )
}